/**
 * @file TasksPage.jsx
 * @location src/pages/TasksPage.jsx
 * @role 업무 페이지 (activeNav === 'tasks') — 매니저/팀원 뷰 분기 wrapper
 *
 * 새 축(매니저 1명 전용):
 *   isManager  → ManagerTasksPage (발신 + 안 읽음/기한 초과 주목 + 전체 테이블)
 *   팀원       → MemberTasksPage  (안 읽음 + 담당 업무 — 핸드셰이크만)
 *
 * 구 [마이/전체] 토글 폐지 (전체를 매니저 기본탭으로 흡수). 권한 게이트는 의미 함수 경유 (canAssignTasks — 현행 isManager 위임, razor ⑳).
 */
import { useApp } from '../store/AppContext';
import { canAssignTasks } from '../utils/permissions';
import { MemberTasksPage } from './MemberTasksPage';
import { ManagerTasksPage } from './ManagerTasksPage';

export function TasksPage({ onToast }) {
  const { S } = useApp();
  const me = (S.members ?? []).find(m => m.id === S.uid);

  return (
    <div className="tasks-page">
      {canAssignTasks(me)
        ? <ManagerTasksPage onToast={onToast} />
        : <MemberTasksPage onToast={onToast} />}
    </div>
  );
}
